import { styled } from '@mui/material/styles';
import { Card, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

export const StyledCard = styled(Card)(({ theme }) => ({
  flex: 1,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

export const StyledCardHeader = styled(CardHeader)({
  padding: '16px',
  height: 'auto',
});

export const StyledCardContent = styled(CardContent)({
  padding: '16px !important',
  height: '469px',
  width: '100%',
});
